'use strict';
import addToCart from './pages/product/addToCart';
import analytics  from './analytics';

function createStepsIndicatorsHandler() {
	var questionsLength = $('.question.main').length;

	updateStepsIndicator(questionsLength);
	goToNextStep(0);
}

function updateStepsIndicator(numberOfSteps) {
	var stepsContainer = $('#quiz-form .step-indicator');
	stepsContainer.empty();

	for (var i = 0; i < numberOfSteps; i++) {
		var step = '<div class="steps step-' + i + '"><span class="pipe">&nbsp;</span><h4>' + (i + 1) + ' | ' + numberOfSteps + '</h4></div>';
		stepsContainer.append(step);
	}
}

function goToNextStep(newQuestion) {
	var stepsContainer = $('#quiz-form .step-indicator');
	stepsContainer.find('.steps').removeClass('active');
	stepsContainer.find('.step-' + newQuestion).addClass('active');
}

function switchQuestions(currentQuestion, newQuestion) {
	$('#question-' + currentQuestion).removeClass('active').hide();
	$('#question-' + newQuestion).addClass('active').show();
	$('.current-question').val(newQuestion);
}

function handlePrevNextLinks(newQuestion) {
	var prevLink = $('.js-quiz-back'),
		nextLink = $('.js-quiz-next'),
		finishLink = $('.js-quiz-finish'),
		firstQuestion = 0,
		lastQuestion = $('.question.main').length - 1;

	prevLink[newQuestion === firstQuestion ? 'hide' : 'show']();
	nextLink[newQuestion === lastQuestion ? 'hide' : 'show']();
	finishLink[newQuestion === lastQuestion ? 'show' : 'hide']();

	goToNextStep(newQuestion);
}

function updateSubmitButtonState() {
	var activeQuestion = $('.question.active'),
		nextLink = $('.js-quiz-next'),
		finishLink = $('.js-quiz-finish');

	if (activeQuestion.data('mandatory')) {
		var inputs = activeQuestion.find('.js-answer-option');

		nextLink.attr("disabled", !inputs.is(":checked"));
		finishLink.attr("disabled", !inputs.is(":checked"));
	} else {
		nextLink.attr("disabled", false);
		finishLink.attr("disabled", false);
	}
}

function updateCustomerSelection(currentQuestion) {
	var questionSelection = currentQuestion.find('input[name="' + currentQuestion.attr('id') + '"]:checked');

	switch (currentQuestion.data('scoring')) {
	case 'age':
		var ageValue = questionSelection.val();
		$('.agerange').val(ageValue);
		break;
	case 'defend':
		var defendValue = questionSelection.length || 0;
		$('.defend').val(defendValue);
		break;
	case 'regenerate':
		var showOptionalQuestion = false;
		var isCorncernNotSelected = !currentQuestion.data('mandatory') && questionSelection.length === 0;

		var regenerateType = questionSelection.first().val();

		var differentChoices = questionSelection.filter(function () {
			var currentValue = $(this).val();

			if (currentValue !== 'basic') {
				regenerateType = currentValue;
				return currentValue;
			}
		});

		if (differentChoices.length > 1 || isCorncernNotSelected) {
			showOptionalQuestion = true;
		}

		if (!currentQuestion.hasClass('additional')) {
			$('.regenerate').val(questionSelection.length || 0);
		}

		if (showOptionalQuestion) {
			var currentQuestionNumber = parseInt($('.current-question').val(), 10);
			var nextQuestion = currentQuestionNumber + 1;

			updateStepsIndicator($('.question.main').length + 1);
			goToNextStep(nextQuestion);
			switchQuestions(currentQuestionNumber, nextQuestion);
			updateSubmitButtonState();

			$('.regenerateConcern').val('');
		} else {
			$('.regenerateConcern').val(regenerateType);
		}

		break;
	}
}

function bindQuizEventsHandler() {
	$('.js-quiz-next').on('click', function () {
		//go back to the question on click of next.
		$(this).closest('.modal-wrapper').scrollTop(0);
		registerClick('next');
		var activeQuestion = $('.question.active');
		var currentQuestion = parseInt($('.current-question').val(), 10);
		var nextQuestion = currentQuestion + 1;

		updateCustomerSelection(activeQuestion);
		switchQuestions(currentQuestion, nextQuestion);
		updateSubmitButtonState();
		handlePrevNextLinks(nextQuestion);
		registerPageView();
	});

	$('.js-quiz-back').on('click', function () {
		registerClick('back');
		var currentQuestion = parseInt($('.current-question').val(), 10);
		var prevQuestion = currentQuestion - 1;
		switchQuestions(currentQuestion, prevQuestion);
		updateSubmitButtonState();
		handlePrevNextLinks(prevQuestion);
		registerPageView();
	});

	$('.js-quiz-finish').on('click', function () {
		registerClick('next');
		var activeQuestion = $('.question.active');
		updateCustomerSelection(activeQuestion);

		var quizForm = $('#quiz-form');

		var emptyFields = quizForm.find('.submit-value').filter(function () {
			return $(this).val() !== '';
		});

		if (emptyFields.length === quizForm.find('.submit-value').length) {
			var baseUrl = quizForm.attr('action');
			window.location.href = baseUrl + '?' + quizForm.find('.submit-value').serialize();
		} else {
			//go back to the question on click of finish when additional question generate.
			$(this).closest('.modal-wrapper').scrollTop(0);
		}
		registerPageView();
	});

	$('.js-answer-option').on('click', function () {
		updateSubmitButtonState();
	});
}

function registerPageViewHandler() {
	var quizModal = $('#quiz-modal'),
		quizContent = quizModal.find('.questions-content');
	var data = {};
	var activeData = quizContent.find('.active');
	data.toolname = 'Suncare Finder';
	data.pagename = activeData.find('.quiz-question h2').text();
	analytics.tagmanager.pageview(data);
};

function registerClickHandler(event) {
	var quizModal = $('#quiz-modal'),
		quizContent = quizModal.find('.questions-content');
	var data = {};
	var activeData = quizContent.find('.active');
	data.event = "consultationBack";
	if (event === 'next') {
		data.event = "consultationNext";
	}
	data.toolname = 'skincareConsultation';
	data.question = activeData.find('.quiz-question h2').text();
	var answers = '';
	activeData.find('.question-body input').each(function (index) {
		if ($(this).is(':checked')) {
			if (answers === '') {
				answers = answers + (index + 1);
			} else {
				answers = answers + ',' + (index + 1);
			}
		}
	});
	data.answers = answers;
	analytics.tagmanager.click(data);
};

export default {
	init: function () {
		addToCart();
	},
	bindQuizEvents: bindQuizEventsHandler,
	createStepsIndicators: createStepsIndicatorsHandler,
	registerPageView: registerPageViewHandler,
	registerClick: registerClickHandler,
}

export const  bindQuizEvents = bindQuizEventsHandler;
export const  createStepsIndicators = createStepsIndicatorsHandler;
export const registerPageView = registerPageViewHandler;
export const registerClick = registerClickHandler;